import * as React from "react";
const SvgTicket = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25 5A.75.75 0 0 1 3 4.25h18a.75.75 0 0 1 .75.75v4.09a.75.75 0 0 1-.75.75c-.977 0-1.704.729-1.704 1.706 0 .976.727 1.704 1.704 1.704a.75.75 0 0 1 .75.75v4.09a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75V14a.75.75 0 0 1 .75-.75c.977 0 1.705-.728 1.705-1.704 0-.977-.728-1.705-1.705-1.705a.75.75 0 0 1-.75-.75zm1.5.75v2.675c1.428.326 2.455 1.575 2.455 3.12S5.178 14.34 3.75 14.667v2.675h16.5v-2.675c-1.428-.327-2.454-1.575-2.454-3.12s1.026-2.795 2.454-3.121V5.75zm4.227 3.34a.75.75 0 0 1 .75-.75h6.546a.75.75 0 0 1 .75.75V14a.75.75 0 0 1-.75.75H8.727a.75.75 0 0 1-.75-.75zm1.5.75v3.41h5.046V9.84z",
    clipRule: "evenodd"
  }
));
export default SvgTicket;
